import React from 'react'
import { Menu } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Hamburger button that opens the app menu. Rendered under a `SheetTrigger` / `DropdownMenuTrigger`
 * with `asChild`, so it forwards the ref and the trigger's props to the underlying button.
 */
export const MenubarTriggerButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof Button>
>((props, ref) => (
  <Button
    ref={ref}
    variant="secondary"
    size="icon"
    className="h-[var(--menubar-button-size)] w-[var(--menubar-button-size)] shadow-[var(--shadow-xs)] active:bg-secondary/90"
    aria-label="Open menu"
    data-text-edit-keepalive=""
    {...props}
  >
    <Menu className="h-4 w-4 text-[var(--menu-icon)]" />
  </Button>
))

MenubarTriggerButton.displayName = 'MenubarTriggerButton'
